import React, { useContext } from 'react';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../shared/app/AuthProvider';

const GreetingBanner = () => {
  const { authUser } = useContext(AuthContext);
  const { t } = useTranslation();

  return (
    <>
      {authUser && (
        <Box>
          {t('GreetingBanner.title')} {authUser.attributes.given_name},{' '}
          {t('ModalFeedback.title')}
        </Box>
      )}
    </>
  );
};

export default GreetingBanner;
